export class AudioStartPlayEvent {
}

export class AudioEndPlayEvent {
}